import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { useState, useEffect } from "react";
import { CustomizationBase } from "./CustomizationBase";
import { CustomizationOptions } from "./Customization";
import * as UTIL from "../../util";
import { fromRenderProps } from "recompose";
import { array } from "yup";
export var HandleSides = function HandleSides(props) {
  var _sidesOptions$, _sidesOptions$$produc, _sidesOptions$2;

  var _props$sidesOptions = props.sidesOptions,
      sidesOptions = _props$sidesOptions === void 0 ? [] : _props$sidesOptions,
      availableAmount = props.availableAmount,
      _props$currentSides = props.currentSides,
      currentSides = _props$currentSides === void 0 ? [] : _props$currentSides,
      _props$setCurrentSide = props.setCurrentSides,
      setCurrentSides = _props$setCurrentSide === void 0 ? function () {
    return "";
  } : _props$setCurrentSide,
      _props$mods = props.mods,
      mods = _props$mods === void 0 ? [] : _props$mods,
      _props$setMods = props.setMods,
      setMods = _props$setMods === void 0 ? function () {
    return console.log("nothingPresent");
  } : _props$setMods,
      index = props.index,
      childSideOptions = props.childSideOptions,
      isEditMode = props.isEditMode,
      _props$editOptions = props.editOptions,
      editOptions = _props$editOptions === void 0 ? [] : _props$editOptions;
  var remaining = availableAmount - currentSides.reduce(function (prev, next) {
    return prev + next.quantity;
  }, 0);
  useEffect(function () {
    if (!isEditMode) {
      return;
    }

    try {
      var camel = UTIL.toCamel(editOptions);
      var removedBasicOptions = camel.filter(function (option) {
        return option.selectedOptions[0].optionName !== option.optionGroupName;
      });
      var sideElementswnumber = removedBasicOptions.filter(function (option) {
        return option.optionGroupName.toLowerCase().indexOf("side") !== -1;
      });
      var sideElements = sideElementswnumber.filter(function (option) {
        return option.optionGroupName.toLowerCase().replace(/\s/g, '').indexOf("numberofsides") === -1;
      });
      var mappedElements = sideElements.map(function (option) {
        return _objectSpread(_objectSpread({}, option), option.selectedOptions[0]);
      });
      var reduced = mappedElements.reduce(function (sum, p) {
        if (!sum[p.optionName]) {
          sum[p.optionName] = 1;
        } else {
          sum[p.optionName] = sum[p.optionName] + 1;
        }

        return sum;
      }, {});

      var onlyUnique = function onlyUnique(value, index, self) {
        var map = self.map(function (e) {
          return e.optionName;
        });
        return map.indexOf(value.optionName) === index;
      };

      var wQuantity = mappedElements.map(function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          optionName: option.optionName,
          quantity: reduced[option.optionName]
        });
      });
      var unique = wQuantity.filter(onlyUnique);
      setCurrentSides(unique);
    } catch (e) {
      console.log(e, "e");
    }
  }, [isEditMode]);

  var handleCheckbox = function handleCheckbox(chainId, parentId, additionalCost, displayName) {
    var newObj = {
      chainId: chainId,
      optionName: displayName,
      parentId: parentId,
      additionalCost: additionalCost,
      quantity: 1
    };
    var currentIndex = currentSides.findIndex(function (side) {
      return side.optionName.toLowerCase() === displayName.toLowerCase();
    });

    if (currentIndex !== -1 || remaining !== 0) {
      var dummySides = _toConsumableArray(currentSides);

      var handledArray = UTIL.filterArrayRemove(dummySides, newObj, "optionName");
      return setCurrentSides(handledArray);
    } else {
      if (availableAmount === 1) {
        // console.log(currentSides);
        var _dummySides = _toConsumableArray(currentSides);

        if (currentSides.indexOf(currentIndex) <= 0) {
          setCurrentSides([]);
          setTimeout(function () {
            _dummySides = _toConsumableArray(currentSides);
            console.log('Dummy sides: ', _dummySides, 'New obj: ', newObj);
            var handledArray = UTIL.filterArrayRemove(_dummySides, newObj, "optionName");
            return setCurrentSides([newObj]);
          }, 10);
        }
      }
    }
  };

  var handleCounter = function handleCounter(amt, chainId, parentId, additionalCost, displayName) {
    if (amt === 0) {
      return handleCheckbox(chainId, parentId, additionalCost, displayName);
    }

    var newObj = {
      chainId: chainId,
      optionName: displayName,
      parentId: parentId,
      additionalCost: additionalCost,
      quantity: amt
    };

    var dummySides = _toConsumableArray(currentSides);

    var handledArray = UTIL.filterArrayAdd(dummySides, newObj, "optionName");
    return setCurrentSides(handledArray);
  };

  var chainList = mods.map(function (option) {
    if (option.selectedOptions) {
      return option.selectedOptions.map(function (childOption) {
        return childOption === null || childOption === void 0 ? void 0 : childOption.optionChainId;
      });
    }

    return;
  }).filter(function (el) {
    return el !== null;
  }).flat();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CustomizationOptions, {
    productModifierOptions: (_sidesOptions$ = sidesOptions[0]) === null || _sidesOptions$ === void 0 ? void 0 : (_sidesOptions$$produc = _sidesOptions$.productModifierOptionsGroup[0]) === null || _sidesOptions$$produc === void 0 ? void 0 : _sidesOptions$$produc.productModifierOptions,
    multiplesAllowed: true,
    optionGroupId: (_sidesOptions$2 = sidesOptions[0]) === null || _sidesOptions$2 === void 0 ? void 0 : _sidesOptions$2.optionGroupId,
    description: "Sides (Choose ".concat(availableAmount, ")"),
    inputType: "checkbox",
    isSides: true,
    remaining: remaining,
    mandatory: false,
    controlledValues: currentSides,
    handleCheckbox: handleCheckbox //Below element is new
    ,
    handleCounter: handleCounter,
    handleSidesPresent: function handleSidesPresent() {
      return "";
    },
    chainList: chainList,
    childOptions: childSideOptions,
    mods: mods,
    setMods: setMods,
    index: index
  }));
};